module.exports = __webpack_public_path__ + "media/images/lb/712-934a6e1ca94b8b08ff498bbdd176ffb4.svg";